import React from 'react';
import { Body, Box, Heading } from '@hover/blueprint';
import { Link } from 'gatsby';
import { ArrowButton } from '@hover/shared-components';
import PartnerTable from './PartnerTable';
import type { ISolutionPartnerTableProps } from '../../../interfaces/ISolutionsPartners';

interface IPartnerListProps extends ISolutionPartnerTableProps {
  heading: string;
  body?: string;
  cta?: {
    href: string;
    label: string;
  };
  desktopRows: number;
}

const PartnerList: React.FC<IPartnerListProps> = ({
  heading,
  body,
  cta,
  partners,
  desktopRows,
}) => (
  <Box
    pt={16}
    pb={{ base: 0, tablet: 16 }}
    maxW={{ base: '100%', desktop: '6xl' }}
    flexDir="column"
    textAlign="center"
    alignItems="center"
    px={{ base: 500, desktop: '56px' }}
    mb={{ base: 0, tablet: 8 }}
  >
    <Heading
      as="h2"
      size={{ base: 500, tablet: 600 }}
      fontWeight={600}
      maxW={{ base: '100%', desktop: '4xl' }}
      marginBottom={{ base: 10, desktop: 12 }}
    >
      {heading}
    </Heading>
    {body && (
      <Body size={600} mb={8} maxW={{ base: '100%', desktop: '4xl' }}>
        {body}
      </Body>
    )}
    {cta && (
      <ArrowButton
        flex={0}
        mb={12}
        variant="minimal"
        whiteSpace="nowrap"
        ml={400}
        as={Link}
        to={cta.href}
      >
        {cta.label}
      </ArrowButton>
    )}
    <PartnerTable partners={partners} desktopRows={desktopRows} />
  </Box>
);

export default PartnerList;
